@if (isAccordion) {
  <sd-accordion-group  data-testid="accordion-group">
    <sd-accordion
      [title]="'checkout.' + type + '.add' | translate"
      [titleLevel]="titleLevel"
      [isOpened]="accordionOpen"
      titleCustomClass="is-body-s is-regular"
      [isDrawer]="true"
      [iconPos]="positionEnum.right"
    >
      <ng-container *ngTemplateOutlet="addAccordionTemplate" />
    </sd-accordion>
  </sd-accordion-group>
}

@if (!isAccordion) {
  <sd-border-wrapper
    [title]="'checkout.' + type + '.add' | translate"
    customClass="is-body-s is-regular"
    data-testid="border-wrapper"
  >
    <ng-container *ngTemplateOutlet="addAccordionTemplate" />
  </sd-border-wrapper>
}

<ng-template #addAccordionTemplate>
  <form novalidate [formGroup]="formAddAction" [ngClass]="{'is-submitted': isSubmitted}">
    <sd-form-input
      formControlName="formInput"
      #SingleInput
      [labelHidden]="true"
      [isFormAddon]="true"
      [validStatus]="validate"
      type="text"
      [placeholder]="'checkout.' + type + '.placeholder' | translate"
      nameField="singleInput"
    >
      <ng-container sd-message>
        <ng-content select="[sd-message]" />
      </ng-container>
    </sd-form-input>

    <button sd-button
      [isSecondary]="validate"
      [type]="validate ? 'button' : 'submit'"
      [icon]="validate ? 'icon-trash' : 'icon-arrow-right'"
      (keydown.enter)="validate ? delete() : submitAction()"
      (click)="validate ? delete() : submitAction()"
    >
      <span class="is-visually-hidden">
        {{ validate ? ('checkout.' + type + '.remove' | translate) : ('checkout.' + type + '.validate' | translate) }}
      </span>
    </button>

    @if (validate) {
      <p class="is-caption">
        <em>{{ description }}</em>
      </p>
    }
  </form>
</ng-template>
